import { useEffect, useState } from "react";

interface EditFieldProps {
    title: string;
    value: string;
    name: string;
    onData: (name: string, value: string) => void;
    error?: string;
    isDisabled?: boolean;
}

function EditField({ title, value, name, onData, error, isDisabled }: EditFieldProps) {
    const [data, setData] = useState(value);

    useEffect(() => {
        setData(value);
    }, [value]);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const newValue = e.target.value;
        setData(newValue);
        onData(newValue, name);
    };

    const id = `input-${name}`;

    return (
        <div className="flex flex-col w-full items-start">
            <label htmlFor={id} className="font-medium mb-[4px]">{title}</label>
            <input
                id={id}
                name={name}
                type="text"
                value={data}
                disabled={isDisabled}
                onChange={handleChange}
                className={`${isDisabled ? 'opacity-45' : 'opacity-100'} outline-none border border-[#e0e0e0] rounded-[4px] py-[4px] px-[8px] w-full h-[46px] focus:border-[#3498db] focus:ring-1 focus:ring-[#3498db] transition-all duration-200`}
            />
            <div className="h-[20px] mt-1">
                {error && <p className="text-red-500 text-sm">{error}</p>}
            </div>
        </div>
    );
}

export default EditField;
